import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCommodity } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type SearchCommoditiesResponse = {
  commodityList: TMSCommodity[];
  message?: string;
};

/**
 * Search commodities by keyword (e.g. Product/List searchFilter). Read-only; results are not persisted.
 * Only supported by some TMS integrations (e.g. GlobalTranz).
 */
export async function searchCommodities(
  tmsID: number,
  customerID: number,
  searchFilter: string,
  freightClass?: string
): Promise<Result<SearchCommoditiesResponse, ApiError>> {
  try {
    const params = new URLSearchParams({
      tmsID: tmsID.toString(),
      customerID: customerID.toString(),
      searchFilter: searchFilter.trim(),
    });

    if (freightClass?.trim()) {
      params.append('freightClass', freightClass.trim());
    }

    const response = await axios.get<SearchCommoditiesResponse>(
      `/commodities/search?${params.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'searchCommodities' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to search commodities' });
    }

    if (error.response?.status === 501) {
      return err({
        message:
          (error.response?.data as SearchCommoditiesResponse)?.message ||
          'Commodity search is not supported for this TMS',
      });
    }

    return err({
      message:
        (error.response?.data as SearchCommoditiesResponse)?.message ||
        'Failed to search commodities',
    });
  }
}
